import styled from 'styled-components';

export const Paper = styled.path`
  color: ${({ theme }) => theme.colors.accent};
`;

export const Pencil = styled.path`
  color: ${({ theme }) => theme.colors.primary};
`;
